import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-form-element',
  templateUrl: './form-element.component.html',
  styleUrls: ['./form-element.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FormElementComponent implements OnInit {

  constructor() {
	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}
}



// WEBPACK FOOTER //
// ./src/app/features/form-element/form-element.component.ts